__webpack_require__.p = "/custom-colors-remapping/onboarding/";